<template>
  <v-container class="stampyt-container fill-height d-flex pa-0" fluid>
    <div class="stampyt-background"></div>
    <div class="primary">
      <div class="my-10">
        <img class="login-logo-stampyt" src="../assets/nextlane_logo_white.png" />
      </div>

      <div class="form-block white">
        <div class="d-flex justify-end">
          <SelectLang></SelectLang>
        </div>
        <IdentityProvider></IdentityProvider>
      </div>
    </div>
  </v-container>
</template>

<script>
import IdentityProvider from '@/components/IdentityProvider.vue'
import SelectLang from '@/components/SelectLang'

export default {
  name: 'Login',
  computed: {
    translate() {
      return this.$t('login')
    }
  },
  methods: {
    login() {
      this.$keycloak.login()
    }
  },
  components: {
    SelectLang,
    IdentityProvider
  }
}
</script>

<style lang="sass" scoped>
.login-logo-stampyt
  max-width: 400px
  width: 100%
  height: auto
  margin: 0 auto
  display: block
.form-block
  max-width: 500px
  margin: 0 auto
  width: 100%
  padding: 20px 0 40px 0
  border-radius: 10px
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.2)

.stampyt-container > div
  width: 50%
  height: 100%
  background-color: white
.stampyt-background
  display: block
  background-image: url('../assets/background-login.png')
  background-size: cover
  background-position: center

@media screen and (max-width: 1023px)
  .stampyt-background
    display: none

@media screen and (max-width: 1023px)
  .stampyt-container > div
    width: 100%

.custom-title
  font-family: 'Fira Sans'
  font-weight: 300
  letter-spacing: 30px !important
  opacity: .8
  font-size: 150px
  white-space: nowrap
  padding-bottom: 100px
  display: block
  text-indent: 30px
  @media (max-width: 960px)
    margin-top: 50px
    font-size: 50px
    letter-spacing: 20px !important
    text-indent: 20px
  @media (max-width: 400px)
    font-size: 20px
    letter-spacing: 15px !important
    text-indent: 15px

.btn-block
  display: flex
  justify-content: center

.v-btn
  margin: 5px 0

.text-1
  margin-top: 30px
  font-size: 16px

.effect-link
  display: inline-block
  overflow: hidden
  padding: 0 !important
  &:before, &:after
    right: 0
    bottom: 0
    background: var(--v-new-primary-darken1)
    transition: transform .3s ease
  &:before
    width: 100%
    height: 2px
    transform:  translateX(-100%)
    transition-delay: .9s
  &:after
    width: 2px
    height: 100%
    transform:  translateY(100%)
    transition-delay: .6s
  > span
    display: block
    padding: 10px
    &:before, &:after
      left: 0
      top: 0
      background: var(--v-new-primary-darken1)
      transition: transform .3s ease
    &:before
      width: 100%
      height: 2px
      transform:  translateX(100%)
      transition-delay: .3s
    &:after
      width: 2px
      height: 100%
      transform:  translateY(-100%)
      transition-delay: 0s

  &:hover:before, &:hover:after, &:hover > span:before, &:hover > span:after
    transform:  translate(0, 0)
  &:hover:before
    transition-delay: 0s
  &:hover:after
    transition-delay: .3s
  &:hover > span:before
    transition-delay: .6s
  &:hover > span:after
    transition-delay: .9s

.bold
  font-weight: 500

h3
  float: left
  width: 100%
  height: 44px
  margin: 30px 0
  line-height: 24px
  text-align: center
  font-weight: normal

a, a > span
  position: relative
  color: var(--v-new-primary-darken1)
  text-decoration: none
  line-height: 24px
  &:before, &:after
    content: ''
    position: absolute
    transition: transform .5s ease
</style>
